import './css/style.css';
import './css/utilities.css';
import Navbar from './components/Navbar';
import Main2 from './components/Main2';
import CategoryContainer from './components/CategoryContainer';
import SubmenuCategory from './components/SubmenuCategory';

// function App() {
//   return (
//     <div className="App">
//       <Navbar />
//       <Main2 />
//     </div>
//   );
// }

function App() {
  return (
    <div className="App">
      <SubmenuCategory />
      <CategoryContainer/>
    </div>
  );
}


export default App;
